import { EsField } from '../../../../services/dtos/riskProducts/rpColumn.dto';

export const DEFAULT_MONITOR_SORT_FIELD: EsField = 'display_name';

export const EXCLUDED_MONITOR_ES_FIELDS = [
  'rating_stability_indicator',
  'potential_rating_action',
  'cs_companyid',
  'rid',
  'cs_sector3_name',
  'cre_previous',
  'cqs_previous',
  'fscore_previous',
  'credit_risk_level_previous',
  'acr_previous',
];

export const COLUMN_PERSISTENCE_KEY = 'monitor-widget-rp-columns';

export const DEFAULT_MONITOR_COLUMNS: EsField[] = [
  'display_name',
  'display_ticker',
  'country_name',
  'model_sector',
  'calc_date',
  'fund_date',
  'cqs',
  'cqs_trend_1y',
  'cqs_volatility',
  'acr',
  'fas',
  'cre_1y',
  'credit_risk_level',
  'credit_risk_trend_6m',
];

export const MONITOR_SIZE_FIELDS: string[] = [
  'cqs',
  'cre_1y',
  'acr',
  'fas',
  'fscore',
  'currency',
  'market_leverage',
  'gross_debt_to_ebitda',
  'net_debt_to_ebitda',
  'ebitda_margin',
  'cqs_change_3m',
  'cqs_change_1y',
  'country_risk_score',
  'cre_3y',
  'cre_5y',
  'cre_change_1w',
  'cre_change_1m',
  'cre_change_ytd',
  'cre_percentile',
  'cre_sector_1_pct',
  'escore',
  'credit_risk_trend_6m',
];
export const MONITOR_SIZE_MAX_WIDTH: number = 70;

export const MONITOR_LONG_TEXT_FIELDS: string[] = [
  'display_name',
  'credit_risk_trend_6m',
  'cqs_trend_1y',
  'model_sector',
  'cs_sector1_name',
  'cs_sector2_name',
  'cqs_trend_3y',
  'cqd',
  'credit_risk_trend_1y',
];
export const MONITOR_LONG_TEXT_MIN_WIDTH: number = 160;
